import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { FoundQuote } from "./Quotes";
import { Link } from "react-router-dom";

const CustomerNumberCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const data = props.dataItem as FoundQuote;

  if (!data.CustomerID) {
      return <td {...props.tdProps}></td>;
  }

  return (
      <td {...props.tdProps}>
          <Link
              to={`/Customers/Customer/${data.CustomerID}`}
              target="_blank"
              style={{ color: '#007bff' }}
          >
              {data.CustomerNumber}
          </Link>
      </td>
  );
}

export default CustomerNumberCell;
